import PropTypes from 'prop-types';
// material
import { Box, Modal, Typography, Button } from '@mui/material';
// ------------------------------------------------------------------------------------------------

ErrorMsgPopup.propTypes = {
    confirm: PropTypes.func,
    msg: PropTypes.string,
    header: PropTypes.string,
};
// ------------------------------------------------------------------------------------------------

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%,-50%)',
    bgcolor: 'background.paper',
    borderRadius: 1.5,
    p: 3,
    width: 390,
    height: 'auto',
    minHeight: 200
}
// ------------------------------------------------------------------------------------------------

export default function ErrorMsgPopup({ confirm, msg, header }) {

    const onClickYes = (event) => {
        confirm(true);
    };

    return (
        <div>
            <Modal open >
                <Box sx={style} >
                    <Typography variant='h6' alignItems='left'>
                        {header}
                    </Typography>

                    <Typography variant='subtitle1' sx={{ my: 3, textAlign: 'center' }}>
                        {msg}
                    </Typography>

                    <Box sx={{ position: 'absolute', bottom: 16, right: 16 }} >
                        <Button type="submit" variant="contained" onClick={onClickYes} > Ok </Button>
                    </Box>
                </Box>
            </Modal>
        </div >
    )
}